module.exports = __webpack_public_path__ + "static/media/Slider3.44cd1e06.png";